import { useCallback, useState } from 'react'

import { ENTITY_TYPES, useAppDispatch } from '@sales-center/common'

import { IServiceTax } from '../typings'
import {
  getLeadOppServiceTax,
  getLocationServiceTax,
  getLocationTaxDetails,
} from '../api'

type State = {
  loading: boolean
  status: 'pending' | 'success' | 'error'
  serviceTax?: IServiceTax
}

export function useGetServiceTax() {
  const dispatch = useAppDispatch()

  const [state, setState] = useState<State>(() => ({
    loading: false,
    status: 'pending',
  }))

  const getForEntity = useCallback(
    async (arg: { entityId: number; entityType: ENTITY_TYPES }) => {
      setState({
        status: 'pending',
        loading: true,
      })

      try {
        const result = await dispatch(getLeadOppServiceTax(arg))
        if (getLeadOppServiceTax.fulfilled.match(result)) {
          setState({
            status: 'success',
            loading: false,
            serviceTax: result.payload,
          })
        } else {
          setState({ status: 'error', loading: true })
        }
      } catch {
        setState({ status: 'error', loading: true })
      }
    },
    [dispatch],
  )

  const getForUnMatchedLocation = useCallback(
    async (arg: {
      entityId: number
      entityType: ENTITY_TYPES
      locationId: number
    }) => {
      setState({
        status: 'pending',
        loading: true,
      })

      try {
        const result = await dispatch(getLocationTaxDetails(arg))
        if (getLocationTaxDetails.fulfilled.match(result)) {
          setState({
            status: 'success',
            loading: false,
            serviceTax: result.payload,
          })
        } else {
          setState({ status: 'error', loading: true })
        }
      } catch {
        setState({ status: 'error', loading: true })
      }
    },
    [dispatch],
  )

  const getForLocation = useCallback(
    async (serviceLocationId: string) => {
      setState({
        status: 'pending',
        loading: true,
      })

      try {
        const result = await dispatch(getLocationServiceTax(serviceLocationId))
        if (getLocationServiceTax.fulfilled.match(result)) {
          setState({
            status: 'success',
            loading: false,
            serviceTax: result.payload,
          })
        } else {
          setState({ status: 'error', loading: true })
        }
      } catch {
        setState({ status: 'error', loading: true })
      }
    },
    [dispatch],
  )

  return {
    ...state,
    getForEntity,
    getForLocation,
    getForUnMatchedLocation,
  }
}
